// removed by extract-text-webpack-plugin
module.exports = {"caption":"_29qck","captionCredit":"G8hlm"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Helpers/Bildtext/Bildtext.scss
 ** module id = 444
 ** module chunks = 0
 **/